export default {
	studio: 'https://file.joshvm.com/resource/studio/JoshVM_win32-1.1.19.v20210913.zip',
	studioPdf: 'https://file.joshvm.com/document/Primary/JoshVMStudio安装使用手册_V1.2.pdf',
	primaryPdf: 'https://file.joshvm.com/document/Primary/JOSH基础开发教程V1.3.pdf',
	ch340: 'https://file.joshvm.com/resource/other/CH340SER.zip',
	Demos: {
		deviceInfo: 'https://file.joshvm.com/resource/sample/DeviceInfoDemo.zip',
		file: 'https://file.joshvm.com/resource/sample/FileDemo.zip',
		sms: 'https://file.joshvm.com/resource/sample/SmsDemo.zip',
		gpio: 'https://file.joshvm.com/resource/sample/GpioDemo.zip',
		gpioReceive: 'https://file.joshvm.com/resource/sample/GPIOReceiveDemo.zip',
		socket: 'https://file.joshvm.com/resource/sample/SocketDemo.zip',
		uart: 'https://file.joshvm.com/resource/sample/UartDemo.zip',
		spiLCD: 'https://file.joshvm.com/resource/sample/SpiLCDDemoESP.zip',
		IICSensor: 'https://file.joshvm.com/resource/sample/IICSensorDemo.zip',
		audio: 'https://file.joshvm.com/resource/sample/AudioDemo.zip',
		media: 'https://file.joshvm.com/resource/sample/MediaDemo.zip',
		wackUp: 'https://file.joshvm.com/resource/sample/WackUpDemo.zip',
		joshAiSpeech: 'https://file.joshvm.com/resource/sample/JoshAiSpeech.zip',
	},
	MEGA8300: {
		introduct: 'https://file.joshvm.com/document/MEGA_8300/JOSH_EVB MEGA8300硬件说明_V1.0.pdf',
		menu: 'https://file.joshvm.com/document/MEGA_8300/JOSH_EVB MEGA8300操作手册_V1.0.pdf',
		model: 'https://file.joshvm.com/document/MEGA_8300/J8300模块硬件接口手册_V1.2.pdf'
	},
	MEGAESP32: {
		lead: 'https://file.joshvm.com/document/MEGA_ESP32/JOSH_EVB MEGA ESP32入门指导手册_V1.0.pdf',
		introduct: 'https://file.joshvm.com/document/MEGA_ESP32/JOSH_EVB MEGA ESP32硬件说明_V1.0.pdf',
		menu: 'https://file.joshvm.com/document/MEGA_ESP32/JOSH_EVB MEGA ESP32操作手册_V1.0.pdf',
		firmware: 'https://file.joshvm.com/resource/firmware/JOSH_EVB MEGA ESP32/JOSH_EVB MEGA ESP32_v1.0.1.zip',
		joshReg: 'https://file.joshvm.com/resource/other/JoshRegTool.exe',
		primaryPdf: 'https://file.joshvm.com/document/MEGA_ESP32/JOSH_EVB MEGA ESP32开发教程V1.2.pdf',
		wifiSet: 'https://file.joshvm.com/resource/other/properties.ini',
		demo: 'https://file.joshvm.com/resource/sample/JOSHDemos-JOSH_EVB MEGA ESP32.zip'
	},
	ESP32: {
		wifiSet: 'https://file.joshvm.com/resource/other/properties.ini',
		update: 'https://file.joshvm.com/document/ESP32/WroverKit/使用ESP32 Flash_Download_Tool 刷写固件.pdf',
		develop: 'https://file.joshvm.com/document/ESP32/WroverKit/使用ESP32开发板调试JOSH应用.pdf',
		firmware: 'https://file.joshvm.com/resource/firmware/ESP32-WROVER-KIT/JOSH_ESP32WROVERKIT_fw_20190911.zip',
		demo: 'https://file.joshvm.com/resource/sample/JOSHDemos-ESP-WROVER-KIT.zip',
		updateMini: 'https://file.joshvm.com/document/ESP32/LyraTMini/ESP32_Mini开发板使用Flash_Download_Tool 刷写固件.pdf',
		developMini: 'https://file.joshvm.com/document/ESP32/LyraTMini/ESP32_Mini开发板使用JOSH应用.pdf',
		firmwareMini: 'https://file.joshvm.com/resource/firmware/ESP-LyraT-Mini/ESP-LyraT-Mini_v1.0.1.zip',
		demoMini: 'https://file.joshvm.com/resource/sample/JOSHDemos-ESP-LyraT-Mini.zip'
	},
	Other: {
		esp32model: 'https://www.espressif.com/sites/default/files/documentation/esp32-wrover-b_datasheet_cn.pdf',
		cp210driver: 'https://www.silabs.com/products/development-tools/software/usb-to-uart-bridge-vcp-drivers'
	}
}


// WEBPACK FOOTER //
// ./src/options/resource.js